
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"var(--status-svg-color)","cx":"22","cy":"22","r":"22"}}),_c('path',{attrs:{"d":"M9 9h26v26H9z"}}),_c('path',{attrs:{"d":"M22 33c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zm0-2.2a8.8 8.8 0 100-17.6 8.8 8.8 0 000 17.6zm-1.1-7.929a2.75 2.75 0 112.2 0V26.4h-2.2v-3.529z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    